<template>
  <section class="all-cases-view" id="auto-sendout-failed-list">
    <div class="navbarComponent">
      <div class="container-default">
        <div class="listings-navbar">
          <el-row>
            <el-col :lg="7">
              <ul class="d-flex list-items-group-15 barcode-print">
                <li>
                  <div class="form-element input-with-icon search-input-lg">
                    <el-input
                      placeholder="Accession ID / Patient Name"
                      v-model="search_string"
                      @input="getAutoCompleteOrders()"
                      :clearable="true"
                    ></el-input>
                    <span>
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid icon"
                      />
                    </span>
                  </div>
                </li>
              </ul>
            </el-col>
            <el-col :lg="17">
              <ul
                class="d-flex flex-wrap justify-content-end list-items-group-15"
              >
                <li>
                  <div class="search-with-date-input">
                    <el-date-picker
                      format="MM-DD-YYYY"
                      v-model="date_of_birth"
                      :disabled-date="disabledDate"
                      @change="fetchCases()"
                      placeholder="Patient DOB"
                      :clearable="true"
                    ></el-date-picker>
                  </div>
                </li>
                <li>
                  <div class="search-with-date-input">
                    <el-date-picker
                      v-model="fromDate"
                      type="date"
                      placeholder="From Date"
                      format="MM-DD-YYYY"
                      :clearable="true"
                      :disabled-date="(date) => date > new Date()"
                      @change="handleCurrentChange(1)"
                      value-format="YYYY-MM-DD"
                      style="width: 100%"
                    />
                  </div>
                </li>
                <li>
                  <div class="search-with-date-input">
                    <el-date-picker
                      v-model="toDate"
                      type="date"
                      placeholder="To Date"
                      format="MM-DD-YYYY"
                      :clearable="true"
                      value-format="YYYY-MM-DD"
                      :disabled-date="(date) => date > new Date()"
                      style="width: 100%"
                      @change="handleCurrentChange(1)"
                    />
                  </div>
                </li>
                <li>
                  <el-button
                    class="filter-toggle-btn"
                    @click="showFilters = !showFilters"
                  >
                    {{ showFilters ? 'Hide Filters' : 'Show Filters' }}
                  </el-button>
                </li>
              </ul>
            </el-col>
          </el-row>
          <transition name="slide-filters">
            <el-row v-if="showFilters" class="mt-10">
              <el-col :span="24">
                <ul class="d-flex list-items-group-15">
                  <li>
                    <div class="form-element search-with-filter-input">
                      <el-select
                        v-model="selectedHospital"
                        placeholder="Ordering Facility"
                        filterable
                        clearable
                        default-first-option
                        value-key="_id"
                        @change="onHospitalChange"
                        remote
                        @focus="onHospitalFocus"
                        :remote-method="remoteMethodFacility"
                        :loading="hospitalsLoading"
                      >
                        <el-option
                          v-for="hospital in hospitalsData.data"
                          :key="hospital"
                          :label="hospital.name"
                          :value="hospital"
                        ></el-option>
                      </el-select>
                    </div>
                  </li>
                  <li>
                    <div class="form-element search-with-filter-input">
                      <el-select
                        v-model="physician"
                        placeholder="Physician"
                        filterable
                        clearable
                        default-first-option
                        @change="handleCurrentChange(1)"
                        @focus="onPhysicianFocus"
                        :loading="physiciansLoading"
                        remote
                        :remote-method="remoteMethodPhysician"
                      >
                        <el-option
                          v-for="physician in physiciansData.data"
                          :key="physician"
                          :label="physician.name"
                          :value="physician._id"
                        ></el-option>
                      </el-select>
                    </div>
                  </li>
                  <li>
                    <div class="form-element search-with-filter-input">
                      <el-select
                        v-model="caseType"
                        placeholder="Case Type"
                        filterable
                        clearable
                        default-first-option
                        :reserve-keyword="false"
                        @change="handleCurrentChange(1)"
                      >
                        <el-option
                          v-for="ct in getLabBasedCaseTypes(caseTypes)"
                          :key="ct"
                          :label="ct.label"
                          :value="ct.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </li>
                </ul>
              </el-col>
            </el-row>
          </transition>
        </div>
      </div>
    </div>
    <div class="container-default" style="padding-top: 0">
      <div class="primary-content-view-new" v-loading="loading">
        <div
          class="listings listings__table listings__all-cases"
          id="auto-sendout-failed-listings"
        >
          <el-table
            :data="getAllAutoSendoutCases.data"
            height="calc(100vh - 200px)"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
            style="width: 100%"
            @sort-change="onChangeSort"
          >
            <el-table-column
              fixed="left"
              prop="accession_id"
              label="ACCESSION ID"
              min-width="150"
              sortable="custom"
            >
              <template #default="scope">
                <div class="name-accession cursor">
                  <span
                    id="accession-id"
                    @click="onView(scope.row._id)"
                  >{{ scope.row.accession_id }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Case Type"
              min-width="125"
              prop="case_types"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <div
                  class="case-type"
                  v-if="scope.row.case_types && scope.row.case_types.length > 1"
                >
                  <el-dropdown>
                    <span class="case-data-type">
                      {{ getCaseTypes(scope.row.case_types)[0] }}
                      <img
                        src="@/assets/images/case-type-arrow.svg"
                        alt="icon"
                      />
                    </span>
                    <template #dropdown>
                      <el-dropdown-menu class="case-type-dropdown">
                        <el-dropdown-item
                          class="cases-view"
                          v-for="(caseType, index) of getCaseTypes(scope.row.case_types)"
                          :key="index"
                        >{{ caseType }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
                <div v-else class="case-type">
                  <span class="case-data-type">{{
                    getCaseTypes(scope.row.case_types)[0]
                  }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="patient_info.first_name"
              label="PATIENT NAME"
              width="160"
              sortable="custom"
              fixed="left"
            >
              <template v-slot="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="
                    convertToUppercase(
                      getPatientNameByInfo(scope.row.patient_info)
                    )
                  "
                  @click="
                    copyTitle(getPatientNameByInfo(scope.row.patient_info))
                  "
                >
                  <span class="text-center ordering_facility-value">{{
                    convertToUppercase(
                      getPatientNameByInfo(scope.row.patient_info)
                    )
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="Patient DOB"
              min-width="120"
              prop="date_of_birth"
            >
              <template #default="scope">
                <div style="cursor: default" v-if="scope.row.patient_info">
                  {{ formatDate(scope.row.patient_info.date_of_birth) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="hospitals"
              label="ORDERING FACILITIES"
              min-width="215"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="scope.row.hospital ? scope.row.hospital.name : '--'"
                >
                  <span class="ordering_facility-value">{{
                    scope.row.hospital ? scope.row.hospital.name : "--"
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="physician" label="PHYSICIAN" min-width="150">
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="
                    scope.row.ordering_physician
                      ? scope.row.ordering_physician.name
                      : '--'
                  "
                >
                  <span class="text-center ordering_facility-value">{{
                    scope.row.ordering_physician
                      ? scope.row.ordering_physician.name
                      : "--"
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="CREATED ON"
              min-width="130"
              prop="created_at"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.created_at">
                  <div class="d-flex">
                    <div class="text-center date pr-5" style="cursor: default">
                      {{
                        momentWithTimezone(scope.row.created_at, "MM-DD-yyyy")
                      }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Status"
              min-width="130"
              prop="status"
              sortable="custom"
            >
              <template v-slot="scope">
                <div class="column-status">
                  <span class="el-dropdown-link">
                    <el-tag style="cursor: default" :type="getStatusType(scope.row.status)">
                      {{ scope.row.status ? scope.row.status.split("_").join(" ") : "--" }}
                    </el-tag>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="action"
              label="Actions"
              width="150"
              fixed="right"
            >
              <template v-slot="scope">
                <ul class="listings__action-buttons">
                  <li @click="onView(scope.row._id)">
                    <el-button class="view-button" title="View Case">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.status == 'ACTIVE' &&
                      hasPermission('send_outs', 'create')
                    "
                  >
                    <el-button
                      class="reports-button"
                      @click="goToSendOutReports(scope.row._id)"
                      :disabled="checkSendOutDisable(scope.row)"
                      :title="
                        checkSendOutDisable(scope.row)
                          ? 'Sendout Already Created'
                          : 'Sendout'
                      "
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/sendouts-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/sendouts-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
          <div class="listings listings__pagination">
            <el-pagination
              v-model:currentPage="page"
              v-model:page-size="pageSize"
              :page-sizes="[25, 50, 75, 100]"
              layout="prev, pager, next, jumper, sizes, total"
              :total="getAllAutoSendoutCases.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import caseConstants from "@/config/constants/caseConstants";
import FilterHelper from "@/mixins/FilterHelper";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseDataHelper from "@/mixins/caseDataHelper";

export default {
  name: "AutoSendoutFailed",
  mixins: [FilterHelper, UserPermissionsHelper, caseDataHelper],
  data() {
    return {
      showFilters: false,
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      search_string: "",
      hospital: "",
      date_of_birth: "",
      fromDate: "",
      toDate: "",
      physician: "",
      caseType: "",
      page: 1,
      pageSize: 25,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      caseTypes: caseConstants.CASE_TYPES_DATA,
      loading: false,
      orderBy: "",
      orderType: "",
      hospitalsData: { data: [] },
      physiciansData: {},
      physiciansLoading: false,
      hospitalsLoading: false,
      selectedHospital: null,
    };
  },
  computed: {
    getStatusType() {
      return (statusVal) => {
        if (!statusVal) return "";
        const status = statusVal.trim();
        if (status == "ACTIVE") return "default";
        if (status == "COMPLETE") return "success";
        if (status == "TEST_REPORTS") return "warning";
        if (status == "TEST_RESULTS") return "info";
        if (status == "ARCHIVED") return "danger";
        return "";
      };
    },
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
    ...mapGetters("cases", ["getAllAutoSendoutCases"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
  },
  mounted() {
    this.setQueryParamsData();
    this.fetchCases();
  },
  methods: {
    onView(caseId) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: caseId },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    goToSendOutReports(caseId) {
      this.$router.push({
        name: "SendOutsView",
        query: { case_id: caseId },
      });
    },
    checkSendOutDisable(row) {
      return row.is_sendout === true;
    },
    async remoteMethodPhysician(query) {
      if (query !== "") {
        await this.fetchAllPhysicians(query);
      } else {
        await this.fetchAllPhysicians();
      }
    },
    onPhysicianFocus() {
      if (!this.physiciansData.data || !this.physiciansData.data.length) {
        this.fetchAllPhysicians();
      }
    },
    async fetchAllPhysicians(physician) {
      try {
        this.physiciansLoading = true;
        let params = { get_all: true };
        if (physician && typeof physician === "string") {
          params.search_string = physician;
        }
        if (this.selectedHospital && this.selectedHospital._id) {
          params.hospital = this.selectedHospital._id;
        }
        await this.$store.dispatch("physicians/fetchAllPhysicians", params);
        this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
        this.physiciansLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async remoteMethodFacility(query) {
      if (query !== "") {
        await this.fetchAllHospitals(query);
      } else {
        await this.fetchAllHospitals();
      }
    },
    onHospitalFocus() {
      if (!this.hospitalsData.data || !this.hospitalsData.data.length) {
        this.fetchAllHospitals();
      }
    },
    onHospitalChange(value) {
      this.hospital = value && value._id ? value._id : "";
      this.physician = "";
      this.physiciansData = { data: [] };
      this.handleCurrentChange(1);
    },
    async fetchAllHospitals(hospital) {
      try {
        this.hospitalsLoading = true;
        let params = { get_all: true, status: "ACTIVE" };
        if (hospital && typeof hospital === "string") {
          params.search_string = hospital;
        }
        await this.$store.dispatch("hospitals/fetchAllHospitals", params);
        this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
        this.hospitalsLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    setQueryParamsData() {
      this.page = this.$route.query.selectedPage
        ? parseInt(this.$route.query.selectedPage)
        : 1;
      this.pageSize = this.$route.query.selectedPageSize
        ? parseInt(this.$route.query.selectedPageSize)
        : 25;
      if (this.$route.query.selectedString) {
        this.search_string = this.$route.query.selectedString;
      }
      if (this.$route.query.selectedCase) {
        this.caseType = this.$route.query.selectedCase;
      }
      if (this.$route.query.selectedPhysician) {
        this.fetchAllPhysicians();
        this.physician = this.$route.query.selectedPhysician;
      }
      if (this.$route.query.selectedHospital) {
        this.hospital = this.$route.query.selectedHospital;
        const restoredName = this.$route.query.selectedHospitalName || "";
        if (this.hospitalsData && Array.isArray(this.hospitalsData.data)) {
          const found = this.hospitalsData.data.find(
            (h) => h._id === this.hospital
          );
          this.selectedHospital =
            found ||
            (this.hospital ? { _id: this.hospital, name: restoredName } : null);
          if (!found && this.selectedHospital) {
            this.hospitalsData.data = [
              ...this.hospitalsData.data,
              this.selectedHospital,
            ];
          }
        } else {
          this.selectedHospital = this.hospital
            ? { _id: this.hospital, name: restoredName }
            : null;
        }
      }
      if (this.$route.query.selectedDateOfBirth) {
        this.date_of_birth = this.$route.query.selectedDateOfBirth;
      }
      if (this.$route.query.selectedOrderBy) {
        this.orderBy = this.$route.query.selectedOrderBy;
      }
      if (this.$route.query.selectedOrderType) {
        this.orderType = this.$route.query.selectedOrderType;
      }
    },
    getAutoCompleteOrders() {
      setTimeout(() => {
        this.page = 1;
        this.fetchCases();
      }, 600);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.fetchCases();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.fetchCases();
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
      this.fetchCases();
    },
    prepareParams() {
      let params = {
        page: this.page,
        limit: this.pageSize,
        auto_sendout_status: "FAILED",
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.date_of_birth) {
        params.date_of_birth = moment(this.date_of_birth).format("YYYY-MM-DD");
      }
      if (this.fromDate) {
        params.from_date = this.fromDate;
      }
      if (this.toDate) {
        params.to_date = this.toDate;
      }
      if (this.hospital) {
        params.hospital = this.hospital;
      }
      if (this.caseType) {
        params.case_type = this.caseType;
      }
      if (this.physician) {
        params.ordering_physician = this.physician;
      }
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      return params;
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedPage: params.page,
        selectedCase: params.case_type,
        selectedHospital: params.hospital,
        selectedHospitalName:
          (this.selectedHospital && this.selectedHospital.name) || undefined,
        selectedDateOfBirth: params.date_of_birth,
        selectedPhysician: params.ordering_physician,
        selectedString: params.search_string,
        selectedPageSize: params.limit,
        selectedOrderBy: params.order_by,
        selectedOrderType: params.order_type,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    async fetchCases() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch("cases/fetchAutoSendoutCases", params);
        if (this.$route.name === "AutoSendoutFailed") {
          this.updateQueryParams(params);
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-toggle-btn.el-button {
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
  height: 35px !important;
  min-height: 35px !important;
  max-height: 35px !important;
  padding: 0 8px !important;
  margin: 0;
  border-radius: 6.4px !important;
  border: 1px solid #dedbdb;
  background: #fff;
  color: #273480;
  cursor: pointer;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.3s ease;
  &:hover,
  &:focus {
    background: #273480;
    border-color: #273480;
    color: #fff;
  }
}
.slide-filters-enter-active,
.slide-filters-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
  max-height: 200px;
  opacity: 1;
}
.slide-filters-enter-from,
.slide-filters-leave-to {
  max-height: 0;
  opacity: 0;
  margin-top: 0 !important;
}
</style>
